module.exports = __webpack_public_path__ + "static/media/2.ef99742d.png";